import useLoginCheck from 'hooks/common/useLoginCheck';
import { getErrorDashboard } from 'lib/api/error';
import { changeError, changeLoading } from 'modules/errorSlice';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

const useErrorDashboard = () => {
  const dispatch = useDispatch();

  const { isLoading, error, data, refetch } = useQuery(
    'errorDashboard',
    getErrorDashboard,
    {
      onError: error => {
        if (error?.response.status === 500) {
          dispatch(changeError(true));
        }
        dispatch(changeLoading({ id: 'errorDashboard', sign: -1 }));
      },
      onSuccess: () => {
        dispatch(changeLoading({ id: 'errorDashboard', sign: -1 }));
      },
    },
  );
  useLoginCheck(error?.response, refetch);

  useEffect(() => {
    if (
      isLoading ||
      error?.response.status === 401 ||
      error?.response.data.error === 'AuthorizationNotFound'
    ) {
      dispatch(changeLoading({ id: 'errorDashboard', sign: 1 }));
    }
  }, [isLoading, error?.response.status, error?.response.data.error, dispatch]);

  return { isLoading, error, errorDashboard: data?.data };
};

export default useErrorDashboard;
